function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492 492",
    style: {
      enableBackground: "new 0 0 492 492"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M88,126c5.333,9.667,15.167,19.667,29.5,30s32.5,18.5,54.5,24.5l297,83l22-81l-297-83l54-38l-19-5 l-54,39l-98-27l-1,8C75.333,81.833,75.833,89,77.5,98S82.667,116.333,88,126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M338,274.5l128,36l4-17l-136-38C336,261.5,337.333,267.833,338,274.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227,226.5l-227-63v18l214,59C218,235.167,222.333,230.5,227,226.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M491,390.5l-226-62c0.667,0,1.5,0.167,2.5,0.5s1.833,0.5,2.5,0.5c14,0,26-5,36-15s15-22,15-36 s-5-26-15-36s-22-15-36-15s-26,4.833-36,14.5c-10,9.666-15,21.833-15,36.5c0,21.333,9.667,36.667,29,46l-248-69l1,180 c10.667,0,20.667-2,30-6c10-4.667,20.333-7,31-7s21,2.333,31,7c10,4,20.167,6,30.5,6s20.5-2,30.5-6c10-4.667,20.333-7,31-7 s21,2.333,31,7c10,4,20.167,6,30.5,6s20.5-2,30.5-6c10-4.667,20.333-7,31-7s21,2.333,31,7c9.333,4,19.333,6,30,6s20.667-2,30-6 c10-4.667,20.333-7,31-7c10.666,0,21.332,2.333,32,7c9.333,4,19.333,6,30,6L491,390.5z M248,278c0-6.333,2.167-11.5,6.5-15.5 c4.333-4,9.5-6,15.5-6s11.167,2,15.5,6s6.5,9.167,6.5,15.5s-2.167,11.667-6.5,16s-9.5,6.5-15.5,6.5s-11.167-2.167-15.5-6.5 S248,284.334,248,278z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDock);
export default __webpack_public_path__ + "static/media/Dock.e92594aa96cb44361aedb8b21b02026f.svg";
export { ForwardRef as ReactComponent };